import React, { useEffect, useState } from "react";
import { CircleUserRound, X } from "lucide-react";
import { commissionsApi } from "../../api/commissions";
import { toast } from "react-hot-toast";

export default function ConverterPop({ isOpen, onClose, token, onConversionSuccess, userCommission }) {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (isOpen) {
      setVisible(true); // Add popup to DOM
      setTimeout(() => setMounted(true), 10); // Add slight delay for animation to start
    } else {
      setMounted(false); // Trigger exit animation
      setTimeout(() => setVisible(false), 300); // Remove from DOM after animation
    }
  }, [isOpen]);
  
  if (!visible) return null;
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Make sure amount is a valid number
    const numAmount = parseFloat(amount);
    if (!amount || isNaN(numAmount) || numAmount <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }
    
    // Make sure userCommission is a valid number for comparison
    const numCommission = parseFloat(userCommission);
    if (isNaN(numCommission)) {
      toast.error("Invalid commission amount");
      return;
    }
    
    if (numAmount > numCommission) {
      toast.error("Amount exceeds available commission");
      return;
    }
    
    setLoading(true);
    try {
      const response = await commissionsApi.convertCommission(token, amount);
      if (response.status === 200) {
        toast.success("Commission converted to wallet successfully");
        onConversionSuccess(response.data);
        setAmount("");
        onClose();
      } else {
        toast.error(response.data.message || "Conversion failed");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-end justify-center px-4 z-[60] font-poppins">
      <div className={`w-full max-w-sm bg-white rounded-t-2xl px-6 pb-6 transform transition-transform duration-300 ${
        mounted ? "translate-y-0" : "translate-y-full"
      }`}>
        {/* Header */}
        <div className="mb-2.5">
          <h2 className="text-sm font-normal text-center mt-2.5">Commission to Wallet</h2>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-2.5">
            <div className="relative">
              <input
                type="number"
                className="w-full text-sm px-4 py-3 border rounded-md focus:outline-none"
                placeholder="Enter amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                disabled={loading}
                required
              />
            </div>
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 p-2 border border-blue-600 text-blue-600 text-sm rounded-md hover:bg-gray-50 transition-colors"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 p-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 transition-colors"
              disabled={loading}
            >
              Convert
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
